module.exports = __webpack_public_path__ + "static/img/FT.ac0f9389.jpg";